import axios from "axios";
import { Constants } from '../utils/Constants';

export function getDataTable(events) {
	return axios.post(`${Constants.baseUrl}/user/list`, events);
}

export function create(form) {
	return axios.post(`${Constants.baseUrl}/user`, form);
}

export function get(id) {
	return axios.get(`${Constants.baseUrl}/user/${id}`);
}

export function update(id, form) {
	return axios.put(`${Constants.baseUrl}/user/${id}`, form);
}

export function destroy(id) {
	return axios.delete(`${Constants.baseUrl}/user/${id}`);
}

export function simpleList(only_actives) {
	if (only_actives) {
		return axios.get(`${Constants.baseUrl}/user/simple-list?only_actives=1`);
	}

	return axios.get(`${Constants.baseUrl}/user/simple-list`);
}

export function getSimpleList() {
	return axios.get(`${Constants.baseUrl}/user/simple-list`);
}

export function updateEmail(email) {
	return axios.post(`${Constants.baseUrl}/user/update-email`, { email });
}